<template lang="html">
  <div
    @mouseover="mouseover"
    @mouseout="mouseout"
    @click="() => $emit('manage-image')"
    :class="[klass, 'profile-image-container flex-box', imageUrl ? 'has-image' : 'no-image']"
  >
    <img :src="imageUrl" v-if="imageUrl && !hover">
    <div v-if="!imageUrl || hover" class="text gray bold">
      {{text}}
    </div>
    <slot />
  </div>
</template>

<script>
import Hoverable from 'src/mixins/Hoverable.js'

export default {
  mixins: [Hoverable],
  computed: {
    text() {
      return this.hover ? this.defaultText : this.hoverText
    }
  },
  props: {
    "klass": {
      type: String,
    },
    "imageUrl": {
      type: String
    },
    "defaultText": {
      type: String,
      default: 'MANAGE IMAGES'
    },
    "hoverText": {
      type: String,
      default: 'UPLOAD UP TO 10 IMAGES'
    },
  }
}
</script>

<style lang="scss" scoped>
.profile-image-container {
  width: 100%;
  background-color: white;
  border: solid 1px #DDDDDD;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;

  * {
    pointer-events: none;
  }

  &.compact, &.adu-footprint, &.compact.no-image, &.compact.has-image, &.adu-footprint.has-image, &.adu-footprint.no-image {
    height: 192px;

    &:hover {
      height: 192px;
    }

    @media screen and (max-width: 768px) {
      height: 176px;

      &:hover {
        height: 176px;
      }
    }
  }

  &.adu-footprint {
    width: 144px;
    padding: 24px;

    img {
      width: 108px;
    }
  }

  .text {
    text-align: center;
    width: 100%;
    transition: 0.3s;
  }

  &.has-image {
    background-color: #EEEFFD;
    border: none;
    height: 304px
  }

  &.no-image {
    height: 304px;
  }

  &:hover {
    background-color: #C5C5C5;
    border: none;
    height: 304px;

    .text {
      color: white !important;
    }
  }

  img {
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }

  @media screen and (max-width: 768px) {
    &.adu-footprint {
      width: 76px;

      img {
        width: 28px;
        height: auto;
      }

      .text {
        display: none;
      }
    }

    &.has-image, &.no-image {
      height: 240px;
      &:hover {
        height: 240px;
      }
    }
  }
}
</style>
